var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"puzzle__item box"},[_c('div',{staticClass:"c-puzzle-picture",class:{ 'last': _vm.isLast }})])}
var staticRenderFns = []

export { render, staticRenderFns }